import api from '@/api';

const resource = 'ei/escola';
const resourceEscolaSIGEG = 'gerencial/escola'

export default {
  getListaEscolaComGrade(data) {
    return api.get(`${resource}/select-escola-grade`, {
      params: data,
    });
  },

  getTodasEscolas(aaletivo) {
    return api.get(`${resource}/getTodasEscolas/${aaletivo}`);
  },

  recebeMerenda() {
    return api.get(`${resourceEscolaSIGEG}/recebe-merenda/`);
  },

  listarEscolaComDepositoMerenda(nomeescola) {
    return api.get(`${resourceEscolaSIGEG}-merenda/`, {
      params: {
        nome: nomeescola
      }
    });
  },
};




